export const findProductInCustomerRecipe = (recipeProduct, customerRecipe) => {
  // attach the more detailed information from the customerRecipe,
  // which comes from the pdp-provider. This importantly adds the 'deselected'
  // property, which tells us to 'gray out' the picker if it's deselected.
  return customerRecipe.find(
    (customerRecipeItem) =>
      customerRecipeItem.productNumber === recipeProduct.productNumber
  );
};

export const handleFormCodeOne = (category, customerRecipe) => {
  let isInRecipe = false;
  let recipeProductOption;
  category.products.forEach((product) => {
    // If any of this category's products are in the recipe,
    // we will need to style the OneSelect as active
    const recipeProduct = findProductInCustomerRecipe(product, customerRecipe);
    if (recipeProduct) {
      isInRecipe = true;
      recipeProductOption = recipeProduct;
    }
  });
  return {
    singlePickerOptions: [
      {
        option: isInRecipe ? recipeProductOption : category.products[0],
        isInRecipe,
      },
    ],
    otherOptions: [],
  };
};

export const handleSingleProductCategory = (product, customerRecipe) => {
  const recipeProduct = findProductInCustomerRecipe(product, customerRecipe);
  return {
    singlePickerOptions: [
      {
        option: recipeProduct || product,
        isInRecipe: recipeProduct ? true : false,
      },
    ],
    otherOptions: [],
  };
};

/* 
  This function splits the category into products that should be rendered
  in a single product picker (ie. OneSelect, ModifierSelect, YesNoCheckbox, Stepper).
  Anything that is not ready to be displayed in a picker gets tucked into
  the `OtherOptions` component, ie. "Add toppings" or "Add syrups".
  Lastly, this function will mark which options are already part of the
  customer's recipe, as these get different styling.
 */
export const getOptionArraysFromProducts = (category, customerRecipe) => {
  // formCode 'one' options and all siblings will get displayed in a OneSelect.
  // We need some special handling for these, so look for them first.
  if (category.products[0]?.form?.formCode === 'one') {
    // A OneSelect can be the only picker for this category,
    // so we can return early
    return handleFormCodeOne(category, customerRecipe);
  }

  // If the category only has one product, it will be shown in a single picker.
  if (category.products.length === 1) {
    // there won't be any other products in this category
    // so we can return early
    return handleSingleProductCategory(category.products[0], customerRecipe);
  }

  // Otherwise, this category has multiple product options, for example
  // a list of syrups. We want to split out any of these that are in the recipe
  // already, as they are displayed in an active single picker component.
  const recipeOptions = [];
  const nonRecipeOptions = [];

  category.products.forEach((product) => {
    const recipeProduct = findProductInCustomerRecipe(product, customerRecipe);
    if (recipeProduct) {
      recipeOptions.push(recipeProduct);
    } else {
      nonRecipeOptions.push(product);
    }
  });

  // now that we've split the recipe options from the non recipe options,
  // we can determine which ones can already be shown in a single picker.
  const singlePickerOptions = [];
  let otherOptions = [];
  // Anything already in the recipe will be shown in a single ready-to-edit picker
  recipeOptions.forEach((option) =>
    singlePickerOptions.push({ option, isInRecipe: true })
  );
  // If a category only has one more option that is not already in the
  // recipe, we will show that in a single ready-to-edit picker as well.
  if (nonRecipeOptions.length === 1) {
    singlePickerOptions.push({
      option: nonRecipeOptions[0],
      isInRecipe: false,
    });
  } else {
    otherOptions = nonRecipeOptions;
  }

  return {
    singlePickerOptions,
    otherOptions,
  };
};
